import { useMutation } from "react-query";
import { doc, updateDoc } from "firebase/firestore";
import { getNextPlayerUserId } from "./useSetNextPlayerMutation";
import { useSelector } from "../../../redux/store";
import { firestore } from "../../../utils/firebase/setupFirebase";

export const usePlayerSolvedMutation = () => {
  const game = useSelector((state) => state.game.game);
  const gameRefUrl = useSelector((state) => state.game.gameRefUrl);
  const gameRef = doc(firestore, gameRefUrl!);

  return useMutation(async (memberId: string) => {
    const updateObject: Record<string, any> = {
      [`membersMap.${memberId}.solved`]: true,
      [`membersMap.${memberId}.solvedTimestamp`]: new Date(),
      activePlayerId: getNextPlayerUserId(game!),
    };
    await updateDoc(gameRef, updateObject);
  });
};
